import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/auth';
import Layout from './components/layout/Layout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import BooksPage from './pages/BooksPage';
import MembersPage from './pages/MembersPage';
import CheckoutsPage from './pages/CheckoutsPage';
import InventoryPage from './pages/InventoryPage';
import ReportsPage from './pages/ReportsPage';
import SettingsPage from './pages/SettingsPage';
import AcquisitionsPage from './pages/AcquisitionsPage';
import SerialsPage from './pages/SerialsPage';
import BranchesPage from './pages/BranchesPage';
import ImportPage from './pages/ImportPage';
import ProfilePage from './pages/ProfilePage';
import NotificationsPage from './pages/NotificationsPage';
import BookDetailPage from './pages/BookDetailPage';
import MemberDetailPage from './pages/MemberDetailPage';
import MarcImportPage from './pages/MarcImportPage';
import FinancialPage from './pages/FinancialPage';
import AccountingLedgerPage from './pages/AccountingLedgerPage';
import StaffPage from './pages/StaffPage';
import OpacLayout from './pages/opac/OpacLayout';
import OpacHomePage from './pages/opac/OpacHomePage';
import OpacCatalogPage from './pages/opac/OpacCatalogPage';
import OpacBookPage from './pages/opac/OpacBookPage';
import OpacLoginPage from './pages/opac/OpacLoginPage';
import OpacMyPage from './pages/opac/OpacMyPage';
import AccountingAccountsPage from './pages/AccountingAccountsPage';

const queryClient = new QueryClient();

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { token } = useAuthStore();
  return token ? <>{children}</> : <Navigate to="/login" />;
};

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Toaster position="top-right" />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/opac" element={<OpacLayout />}>
            <Route index element={<OpacHomePage />} />
            <Route path="catalog" element={<OpacCatalogPage />} />
            <Route path="book/:id" element={<OpacBookPage />} />
            <Route path="login" element={<OpacLoginPage />} />
            <Route path="my" element={<OpacMyPage />} />
          </Route>
          <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
            <Route index element={<DashboardPage />} />
            <Route path="books" element={<BooksPage />} />
            <Route path="members" element={<MembersPage />} />
            <Route path="checkouts" element={<CheckoutsPage />} />
            <Route path="members/:id" element={<MemberDetailPage />} />
            <Route path="books/:id" element={<BookDetailPage />} />
            <Route path="notifications" element={<NotificationsPage />} />
            <Route path="branches" element={<BranchesPage />} />
            <Route path="serials" element={<SerialsPage />} />
            <Route path="acquisitions" element={<AcquisitionsPage />} />
            <Route path="import" element={<ImportPage />} />
            <Route path="marc" element={<MarcImportPage />} />
            <Route path="financial" element={<FinancialPage />} />
            <Route path="accounting-accounts" element={<AccountingAccountsPage />} />
            <Route path="accounting" element={<AccountingLedgerPage />} />
            <Route path="staff" element={<StaffPage />} />
            <Route path="profile" element={<ProfilePage />} />
            <Route path="settings" element={<SettingsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="inventory" element={<InventoryPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
